import { TallLayout } from "common/components/layouts/TallLayout";
import { NavigationTabs } from "common/components/tabs/NavigationTabs";
import { H1 } from "common/components/Typography";
import * as React from "react";
import { ReactNode } from "react";
import { ContentBreadcrumbFragment_context } from "__generated__/types";
import styles from "./NormalTabbedLayout.module.css";

export interface NavigationTab {
  title: string;
  path: string;
  content: ReactNode;
}

interface Props {
  title: string;
  context?: ContentBreadcrumbFragment_context[];
  isAdmin?: boolean;
  navigationTabs: NavigationTab[];
  aboveTabs?: React.ReactNode;
  footer?: React.ReactNode;
}

export const NormalTabbedLayout: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  context = [],
  isAdmin = false,
  navigationTabs,
  aboveTabs,
  footer,
}) => {
  return (
    <TallLayout context={context} isAdmin={isAdmin}>
      <H1>{title}</H1>
      {aboveTabs && <section className={styles.aboveTabs}>{aboveTabs}</section>}
      <NavigationTabs
        extraTabListClassName={styles.tabList}
        extraTabPanelClassName={styles.tabPanel}
        routes={navigationTabs}
      />
      {footer && <div className={styles.footer}>{footer}</div>}
    </TallLayout>
  );
};
